import axios from 'axios'

export default {
  getStripeInfo (token) {
    return axios.get(`payment/${token}`)
  },
}
